/*
  ######  ########    ###    ########   ######  ##     ##
 ##       ##        ##   ##  ##     ## ##       ##     ##
  ######  ######   ##     ## ########  ##       #########
       ## ##       ######### ##   ##   ##       ##     ##
  ######  ######## ##     ## ##     ##  ######  ##     ##
*/
const searchInstanceList = document.getElementsByClassName('js-search')
const searchInputList = document.getElementsByClassName('js-search-input')
let isSuggestOpen = false
window.addEventListener('click', function (e) {
  // 指定のセレクタに該当する
  if (!isSuggestOpen && e.target.closest('.js-search')) {
    e.target.closest('.js-search').classList.add('active')
    isSuggestOpen = true
    return
  }

  if (isSuggestOpen && !e.target.closest('.js-search.active')) {
    document.querySelector('.js-search.active').classList.remove('active')
    isSuggestOpen = false
  }
})

/*
         ########    ###     ######              ###          ##    ###    ##     ##
            ##     ##   ##  ##                 ##   ##        ##  ##   ##    ## ##
 #######    ##    ##     ## ##   #### ####### ##     ##       ## ##     ##    ###
            ##    ######### ##    ##          ######### ##    ## #########   ## ##
            ##    ##     ##  ######           ##     ##  ######  ##     ## ##     ##
*/
tagAjax()
function tagAjax() {
  let ajax = false // Ajaxリクエスト
  let ajaxResponse = '' // 最後のレスポンスを格納する

  let ajaxWord = ''
  if (document.getElementsByClassName('js-tagAjax')) {
    window.addEventListener('input', (e) => {
      if (e.target.classList.contains('js-tagAjax')) {
        e.preventDefault()
        const item = e.target
        const inputKeyword = item.value.trim() // スペース等を除去した入力内容を取得
        if (ajaxWord === inputKeyword) {
          // キーワードが変わっていなければ処理しない
          return false
        }
        ajaxWord = inputKeyword

        if (ajaxWord === '') {
          // キーワードが空ならクリーンアップ
          const to = item.dataset.to.split(',') // ,区切りで配列に変換

          for (let index = 0; index < to.length; index++) {
            const itemTo = document.querySelector(to[index])
            itemTo.innerHTML = ''
          }
          return
        }

        const url = item.dataset.url + encodeURI(ajaxWord) // 取得先
        const to = item.dataset.to // 差し替え要素
        applyTagAjax(url, to, item.id)
      }
    })
  }

  /**
   * Ajax処理を実行する
   * @param url {string} 取得先のURL
   * @param to {string} 取得先のセレクタ　,区切りで複数指定
   * @param id {string} inputのID
   */
  function applyTagAjax(url, to, id) {
    to = to.split(',') // ,区切りで配列に変換

    // Ajaxと明示するパラメータを付ける
    url += (~url.indexOf('?') ? '&' : '?') + 'ajax=1'

    const loadingItem = document.createElement('div')
    loadingItem.className = 'md-loading active'

    if (ajax) {
      // 既に通信中なら切断
      ajax.abort()
    }

    ajax = new XMLHttpRequest() // Ajaxリクエスト
    ajax.open('GET', url, true) // GET/POST, URL, 非同期処理
    ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest') // Ajaxでのアクセスと明示するリクエストヘッダー
    // キャッシュせず最新のデータを取る場合のリクエストヘッダー3種
    // ajax.setRequestHeader('Pragma', 'no-cache')
    // ajax.setRequestHeader('Cache-Control', 'no-cache')
    // ajax.setRequestHeader('If-Modified-Since', 'Thu, 01 Jun 1970 00:00:00 GMT')
    ajax.responseType = 'json' // 取得タイプ document text json
    ajax.timeout = 10000 // タイムアウト判定時間
    ajax.send() // リクエスト実行
    ajax.onload = function () {
      // アクセス成功
      if (ajax.status < 200 || ajax.status >= 400) {
        console.log('Error: Code ' + ajax.status) // エラー
        return
      }

      if (ajax.response === ajaxResponse) {
        // 前と結果が同じなら何もしない
        return
      }
      ajaxResponse = ajax.response // 取得結果を更新

      let ajaxData = ajaxResponse // 実際に使用するデータ

      // IEは取得タイプJSONをtextで受け取るのでJSONにパースする
      if (navigator.userAgent.indexOf('Trident') !== -1 && JSON) {
        ajaxData = JSON.parse(ajaxData)
      }

      let html = ''

      // 取得したJSONをタグに加工する
      for (let index = 0; index < ajaxData.length; index++) {
        const tag = ajaxData[index]

        if (tag === ajaxWord) {
          continue // 入力内容と同じ単語はスキップ
        }
        html += `
<button type="button" class="js-search-insert suggest__item flex vcenter bet" data-text="${tag}" data-input="${id}">
  <div class="is-false suggest__icon flex vcenter hcenter"><i class="icon-tag"></i></div>
  <div class="is-false suggest__name">
      ${tag}
  </div>
</button>
`
      }

      for (let index = 0; index < to.length; index++) {
        const itemTo = document.querySelector(to[index])
        itemTo.innerHTML = html
      }
    }
    ajax.ontimeout = function (e) {
      // タイムアウト
    }
    ajax.onerror = function () {
      // Ajax処理失敗
    }
    ajax.onloadend = function () {
      // 受信成否に関わらず実行
      ajax = false
    }
  }

  /*
         #### ##    ##  ######  ######## ########  ########
          ##  ####  ## ##       ##       ##     ##    ##
 #######  ##  ## ## ##  ######  ######   ########     ##
          ##  ##  ####       ## ##       ##   ##      ##
         #### ##    ##  ######  ######## ##     ##    ##
*/

  window.addEventListener('click', function (e) {
    // 指定のクラスを持たない
    if (!e.target.classList.contains('js-search-insert')) {
      return
    }
    const input = e.target.dataset.input
    for (const item of searchInputList) {
      item.value = e.target.dataset.text + ' '
    }
    const suggestBox = document.getElementsByClassName('js-search-suggest')
    for (let index = 0; index < suggestBox.length; index++) {
      suggestBox[index].innerHTML = ''
    }

    const focusInput = document.getElementById(input) // フォーカスする入力欄を確定
    focusInput.focus() // フォーカスを戻す

    // サジェスト処理を再実行
    ajaxWord = e.target.dataset.text
    const url = focusInput.dataset.url + encodeURI(ajaxWord) // 取得先
    const to = focusInput.dataset.to // 差し替え要素
    applyTagAjax(url, to, input)
  })

  //                ##  ##   ##  ###    ###  #####
  //                ##  ##   ##  ## #  # ##  ##  ##
  //  ########      ##  ##   ##  ##  ##  ##  #####
  //            ##  ##  ##   ##  ##      ##  ##
  //             ####    #####   ##      ##  ##

  window.addEventListener('click', function (e) {
    // 指定のクラスを持たない
    if (!e.target.classList.contains('js-search-jump')) {
      return
    }
    const input = e.target.dataset.input
    for (const item of searchInputList) {
      item.value = e.target.dataset.text

      item.closest('form').submit() // すぐに飛ぶ
      return
    }
  })

  /*
         ##     ## ####  ######  ########  #######  ########  ##    ##
         ##     ##  ##  ##          ##    ##     ## ##     ##   ####
 ####### #########  ##   ######     ##    ##     ## ########     ##
         ##     ##  ##        ##    ##    ##     ## ##   ##      ##
         ##     ## ####  ######     ##     #######  ##     ##    ##
*/
  // GETパラメータ取得
  const params = new URL(document.location).searchParams
  let getKeyword = params.get('keyword')

  let searchHistory = localStorage.getItem('searchHistory') // localStorageに保存したデータを取得
  // 配列に補正する
  if (!searchHistory) {
    searchHistory = []
  } else {
    searchHistory = searchHistory.split(',') // ,区切りで配列に変換
  }

  // $_GET['keyword']を確認したら履歴に追加
  if (getKeyword) {
    getKeyword = getKeyword.trim() // 末端スペースを除去
    // 履歴内に同じワードがあったら古い方を削除
    for (let i = 0; i < searchHistory.length; i++) {
      if (searchHistory[i] === getKeyword) {
        searchHistory.splice(i, 1) // 要素を削除
      }
    }
    searchHistory.unshift(getKeyword) // 配列の先頭に追加

    searchHistory.filter((v) => v) // 空要素削除

    searchHistory.splice(30, 1) // 0始まりの指定番目から指定個数の要素を削除

    const storageData = searchHistory.join(',') // 配列を,区切りで文字列に変換
    localStorage.setItem('searchHistory', storageData) // localStorageにデータを保存
  }

  const historyList = document.getElementsByClassName('js-search-history')
  if (searchInputList[0]) {
    let html = ''
    // 取得した検索履歴をタグに加工する
    for (let index = 0; index < searchHistory.length; index++) {
      const text = searchHistory[index]

      html += `
<div class="suggest__frame">
<button type="button" class="js-search-jump suggest__item flex vcenter bet" data-text="${text}" data-input="search-■■■">
  <div class="is-false suggest__icon flex vcenter hcenter"><i class="icon-after"></i></div>
  <div class="is-false suggest__name">
      ${text}
  </div>
</button>
    <button type="button" class="js-search-removeHistory suggest__item suggest__item--del flex vcenter hcenter" data-text="${text}">
        削除
    </button>
</div>
`
    }

    for (const history of historyList) {
      const inputID = history.dataset.id
      const addHtml = html.replace(/■■■/g, inputID) // IDを設定する
      history.innerHTML = addHtml
    }
  }

  /*
         ########  ######## ##               ##     ## ####  ######
         ##     ## ##       ##               ##     ##  ##  ##
 ####### ##     ## ######   ##       ####### #########  ##   ######
         ##     ## ##       ##               ##     ##  ##        ##
         ########  ######## ########         ##     ## ####  ######
*/

  window.addEventListener('click', function (e) {
    // 指定のクラスを持つ
    if (!e.target.classList.contains('js-search-removeHistory')) {
      return
    }
    const removeText = e.target.dataset.text

    for (let i = 0; i < searchHistory.length; i++) {
      if (searchHistory[i] === removeText) {
        searchHistory.splice(i, 1) // 要素を削除
      }
    }
    const storageData = searchHistory.join(',') // 配列を,区切りで文字列に変換
    localStorage.setItem('searchHistory', storageData) // localStorageにデータを保存

    const removeDom = document.querySelectorAll(
      '.js-search-insert[data-text="' + removeText + '"],.js-search-removeHistory[data-text="' + removeText + '"]'
    )
    for (const iterator of removeDom) {
      iterator.style.display = 'none'
    }
  })
}
